// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
import { MemberListFragmentFragmentDoc } from "./Fragment.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type MembersQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
}>;

export type MembersQuery = {
  __typename?: "GraphqlQuery";
  getOrganizationDetails?: {
    __typename?: "Organization";
    id: string;
    permittedToInviteMembers: boolean;
    samlIntegration?: {
      __typename?: "SamlIntegration";
      id: string;
      idpEntityId: string;
    } | null;
    memberships: Array<{
      __typename?: "OrganizationMembership";
      id: string;
      createdAt: number;
      email: string;
      samlUid?: string | null;
      accepted: boolean;
      expired: boolean;
      user?: {
        __typename?: "User";
        id: string;
        avatarUrl?: string | null;
        fullname?: string | null;
      } | null;
      permissions?: Array<{
        __typename?: "OrganizationPermission";
        id: string;
        restricted: boolean;
        view: boolean;
        modify: boolean;
        billing: boolean;
        api: boolean;
        manage: boolean;
        createWorkbooks: boolean;
      } | null> | null;
    }>;
  } | null;
};

export const MembersDocument = gql`
  query Members($organizationSlug: ID!) {
    getOrganizationDetails(organizationSlug: $organizationSlug) {
      ...MemberListFragment
    }
  }
  ${MemberListFragmentFragmentDoc}
`;

/**
 * __useMembersQuery__
 *
 * To run a query within a React component, call `useMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembersQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *   },
 * });
 */
export function useMembersQuery(
  baseOptions: Apollo.QueryHookOptions<MembersQuery, MembersQueryVariables> &
    ({ variables: MembersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MembersQuery, MembersQueryVariables>(
    MembersDocument,
    options,
  );
}
export function useMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MembersQuery,
    MembersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MembersQuery, MembersQueryVariables>(
    MembersDocument,
    options,
  );
}
// @ts-ignore
export function useMembersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MembersQuery,
    MembersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<MembersQuery, MembersQueryVariables>;
export function useMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MembersQuery, MembersQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  MembersQuery | undefined,
  MembersQueryVariables
>;
export function useMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MembersQuery, MembersQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MembersQuery, MembersQueryVariables>(
    MembersDocument,
    options,
  );
}
export type MembersQueryHookResult = ReturnType<typeof useMembersQuery>;
export type MembersLazyQueryHookResult = ReturnType<typeof useMembersLazyQuery>;
export type MembersSuspenseQueryHookResult = ReturnType<
  typeof useMembersSuspenseQuery
>;
export type MembersQueryResult = Apollo.QueryResult<
  MembersQuery,
  MembersQueryVariables
>;
